import { render, staticRenderFns } from "./EdiData.vue?vue&type=template&id=4b4968c6&"
import script from "./EdiData.vue?vue&type=script&lang=js&"
export * from "./EdiData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports